<app-material>
    <app-tabs class="header"
              header
              *ngIf="!loading"
              [tabs]="tabs"
              [material]="false">
    </app-tabs>
    <ng-container body>
        <router-outlet *ngIf="!loading else loader"></router-outlet>
    </ng-container>
</app-material>


<ng-template #loader>
    <div class="loader">
        <app-loading-spinner></app-loading-spinner>
    </div>
</ng-template>

